import { Component} from '@angular/core';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent{

  constructor() { }
  year: number = new Date().getFullYear();

  get isOpenNow(): boolean {
    const now = new Date();
    // Saturday is day 6. Regular hours: Noon to 4:00 PM (12:00 to 16:00)
    const isSaturday = now.getDay() === 6;
    const hour = now.getHours();
    return isSaturday && hour >= 12 && hour < 16;
  }
}